import type React from 'react';
import type { KindlyTriggerProps as Props } from './kindly-trigger.types';
import { useKindlyChat } from './use-kindly-bot';

const KindlyTrigger: React.FC<Props> = ({ botKey }) => {
  useKindlyChat(botKey);
  return null;
};

export default KindlyTrigger;
